var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcConstituciones(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_constituciones",
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_208",
    "data-name": "Rect\\xE1ngulo 208",
    width: 25,
    height: 25,
    transform: "translate(0.5 0.5)",
    fill: "#5a5a5a",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "kdpHV9.tif",
    transform: "translate(2.282 2.214)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_994",
    "data-name": "Grupo 994"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_456",
    "data-name": "Trazado 456",
    d: "M3.8,6.362V6.123c.014-.063.03-.126.041-.19A2.549,2.549,0,0,1,5.536,3.8c.109-.041.222-.071.334-.105H19.636a.494.494,0,0,0,.089.037,2.736,2.736,0,0,1,2.234,2.087,6.347,6.347,0,0,1,.118.852c.058-.029.114-.062.173-.088.394-.169.786-.346,1.186-.5.271-.106.452-.056.568.113s.084.32-.073.564c-.331.512-.666,1.022-.962,1.554a7.551,7.551,0,0,0-.67,1.723c.328.107.64.214.954.309a.416.416,0,0,1,.106.79c-.38.255-.754.517-1.138.765a.332.332,0,0,0-.176.318q.008,4.325,0,8.65c0,.064.006.13.01.205.076,0,.141.009.205.009.437,0,.875,0,1.313,0a.419.419,0,0,1,.469.485A2.6,2.6,0,0,1,21.983,24.1H9.888a5,5,0,0,1-.82-.329,2.525,2.525,0,0,1-1.245-2.262q-.013-7.26,0-14.521V6.716H7.587c-1.073,0-2.147-.006-3.221,0A.517.517,0,0,1,3.8,6.362Zm17.428,6.218c-.072.045-.116.071-.159.1-.79.535-1.581,1.068-2.367,1.611a.588.588,0,0,0-.207.27c-.149.41-.275.829-.417,1.243a.4.4,0,0,1-.658.22.425.425,0,0,1-.1-.492,14.766,14.766,0,0,0,.509-1.689,16.219,16.219,0,0,1,.584-2.389,8.772,8.772,0,0,1,2.34-3.759,1.335,1.335,0,0,0,.491-1.169,2.007,2.007,0,0,0-2.029-2.032q-5.54-.007-11.079,0c-.048,0-.1.01-.17.018a3.1,3.1,0,0,1,.66,2.139q-.017,7.335,0,14.668a2.8,2.8,0,0,0,.117.822,1.521,1.521,0,0,0,2,1.056A1.7,1.7,0,0,0,11.8,21.645c.039-.457.145-.568.6-.568h8.825ZM23.2,21.9H12.6a2.927,2.927,0,0,1-.626,1.392c.056.006.076.009.1.009q4.782,0,9.563-.005a1.48,1.48,0,0,0,.558-.116A1.718,1.718,0,0,0,23.2,21.9ZM22.523,7.374a6.68,6.68,0,0,0-2.506,2.511,10.319,10.319,0,0,0-1.23,3.363l3.494-2.367c-.178-.061-.327-.113-.477-.161-.374-.122-.451-.27-.354-.656A11.658,11.658,0,0,1,22.523,7.374ZM7.752,5.891a1.626,1.626,0,0,0-1.589-1.4A1.62,1.62,0,0,0,4.7,5.891Z",
    transform: "translate(-3.8 -3.691)",
    fill: "#5a5a5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_457",
    "data-name": "Trazado 457",
    d: "M25.984,28.319a1.739,1.739,0,1,1,1.738-1.745A1.743,1.743,0,0,1,25.984,28.319Zm-.931-1.741a.926.926,0,0,0,.927.936.944.944,0,0,0,.939-.934.955.955,0,0,0-.936-.941A.936.936,0,0,0,25.053,26.578Z",
    transform: "translate(-11.449 -11.607)",
    fill: "#5a5a5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_458",
    "data-name": "Trazado 458",
    d: "M17.415,10.2c-.828,0-1.656,0-2.484,0a.42.42,0,0,1-.462-.293.388.388,0,0,1,.271-.5,1.228,1.228,0,0,1,.3-.027q2.394,0,4.788,0a1.7,1.7,0,0,1,.179,0,.4.4,0,0,1,.4.427.4.4,0,0,1-.423.384c-.218.006-.437,0-.656,0Z",
    transform: "translate(-7.786 -5.822)",
    fill: "#5a5a5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_459",
    "data-name": "Trazado 459",
    d: "M17.421,19.97c-.854,0-1.708,0-2.563,0a.38.38,0,0,1-.394-.3.367.367,0,0,1,.165-.431.456.456,0,0,1,.242-.067q2.553-.006,5.106,0a.4.4,0,1,1,.008.8C19.129,19.973,18.275,19.971,17.421,19.97Z",
    transform: "translate(-7.785 -9.485)",
    fill: "#5a5a5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_460",
    "data-name": "Trazado 460",
    d: "M17.436,16.716c-.854,0-1.708,0-2.563,0a.4.4,0,0,1-.421-.342.388.388,0,0,1,.249-.427.972.972,0,0,1,.293-.03q2.106,0,4.212,0c.252,0,.5,0,.755,0,.279,0,.44.154.439.4a.39.39,0,0,1-.441.4C19.118,16.717,18.277,16.716,17.436,16.716Z",
    transform: "translate(-7.784 -8.265)",
    fill: "#5a5a5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_461",
    "data-name": "Trazado 461",
    d: "M17.435,13.46c-.841,0-1.682,0-2.523,0a.418.418,0,0,1-.464-.365.4.4,0,0,1,.308-.427,1.41,1.41,0,0,1,.257-.015H19.84c.059,0,.12,0,.178.006a.384.384,0,0,1,.38.419.388.388,0,0,1-.4.382c-.47.006-.94,0-1.41,0Z",
    transform: "translate(-7.784 -7.045)",
    fill: "#5a5a5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_462",
    "data-name": "Trazado 462",
    d: "M16.756,22.423h1.83a.353.353,0,0,1,.384.253.6.6,0,0,1-.066.4.409.409,0,0,1-.3.141q-1.869.014-3.739,0a.4.4,0,0,1-.416-.412.414.414,0,0,1,.444-.389C15.51,22.421,16.132,22.423,16.756,22.423Z",
    transform: "translate(-7.783 -10.701)",
    fill: "#5a5a5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_463",
    "data-name": "Trazado 463",
    d: "M23.1,23.223a.391.391,0,0,1-.407-.394.407.407,0,0,1,.4-.4.392.392,0,0,1,.392.39A.381.381,0,0,1,23.1,23.223Z",
    transform: "translate(-10.869 -10.702)",
    fill: "#5a5a5a"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcConstituciones);
export default __webpack_public_path__ + "static/media/ic_constituciones.144434e28efd0164bf52d127e75b251b.svg";
export { ForwardRef as ReactComponent };